import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const TickThick = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 4C25.6785 4.00023 25.3618 4.07795 25.0768 4.22656C24.7917 4.37518 24.5467 4.59032 24.3625 4.85375L11.7287 22.9L7.41497 18.5863C7.03985 18.2111 6.53109 18.0004 6.00059 18.0004C5.4701 18.0004 4.96133 18.2111 4.58622 18.5863C4.2111 18.9614 4.00037 19.4701 4.00037 20.0006C4.00037 20.5311 4.2111 21.0399 4.58622 21.415L10.5862 27.415C10.7915 27.6202 11.0389 27.7782 11.3114 27.8782C11.5839 27.9781 11.8748 28.0176 12.1641 27.9938C12.4533 27.97 12.734 27.8836 12.9864 27.7404C13.2389 27.5973 13.4572 27.401 13.6262 27.165L27.6375 7.14625C27.847 6.8466 27.9705 6.49523 27.9943 6.13034C28.0181 5.76545 27.9415 5.40101 27.7726 5.07665C27.6038 4.75229 27.3493 4.48041 27.0368 4.29059C26.7242 4.10077 26.3656 4.00026 26 4V4Z" />
	</svg>
);

export default TickThick;
